import { Image, Button } from 'react-bootstrap'
import { IoDocumentOutline } from 'react-icons/io5'

import ServicesDesktop from './Services.Desktop'
import ImgVehicleMobile from '../../assets/images/car/vehicle-desktop.svg'
import PhotosDesktop from './Photo.desktop'
import { numberFormatCurrency } from '../../utils/helpers'
import { getCarInfo } from '../../utils/invoice'

const ViewDesktop = ({ vehicle, index, onShowPhoto }) => {
	const identity = (index + 1).toString()
	const { image, year = '', vin = '', stock = '', total = 0, serviceLines = {} } = vehicle

	return (
		<div className='m-4 shadow'>
			<div className='p-3'>
				<div className='d-flex'>
					<span className='d-inlone-block fw-bold'>{identity.padStart(2, identity)}</span>
					<div className='' style={{ width: '200px', height: '104px' }}>
						<Image
							src={image || ImgVehicleMobile}
							className='w-100 h-100'
							style={{ objectFit: 'contain' }}
						/>
					</div>
					<div className='px-3 flex-grow-1'>
						<span className='d-block'>{year}</span>
						<h5 className='fw-bold'>{getCarInfo(vehicle)}</h5>
						<div className='d-flex fs-sub flex-wrap'>
							{/* <span className='d-inline-block border-end pe-2 me-2'>
								Services: {getServiceLines(vehicle)}
							</span> */}
							<span className='d-inline-block border-end pe-2 me-2'>
								STOCK/RO: {stock || 'None Added'}
							</span>
							<span>VIN: {vin || 'None Added'}</span>
						</div>
					</div>
					<div className='text-end'>
						<h5 className='fw-bold'>{numberFormatCurrency('usd', total)}</h5>
						{/* <Button variant='default' className='text-primary p-0 fw-bold fs-sub text-uppercase'>
							View insurance supplement
							<IoDocumentOutline size={16} className='ms-2' />
						</Button> */}
					</div>
				</div>

        <ServicesDesktop serviceLines={serviceLines} />
        <PhotosDesktop onShowPhoto={onShowPhoto} vehicle={vehicle} />
      </div>
		</div>
	)
}

export default ViewDesktop
